// extracted by mini-css-extract-plugin
export default {"title":"edit-user-permissions-modal_title__kq-i6"};